import {produce} from 'immer';
import React from 'react';
import {ContentTitle} from 'src/design/atoms/Typography';
import {FormField} from 'src/app/forms/FormField';
import type {IFormFieldV2} from 'src/types/FormV2';
import {
  useGetSelectedField,
  useUpdateSelectedField,
} from '../../../hooks/useFormBuilder';

// Define the settings fields using IFormFieldV2
const leastValueField: IFormFieldV2 = {
  name: 'leastValueText',
  label: 'Least Text Value',
  type: 'text',
  description: 'The text to display for the lowest value on the scale',
};

const mostValueField: IFormFieldV2 = {
  name: 'mostValueText',
  label: 'Most Text Value',
  type: 'text',
  description: 'The text to display for the highest value on the scale',
};

export const ScaleSettings = React.memo(() => {
  const field = useGetSelectedField();
  const updateSelectedField = useUpdateSelectedField();

  const handleScaleTextLeastChange = React.useCallback(
    (name: string, value: string) => {
      if (!field) return;
      updateSelectedField(
        produce(field, draft => {
          draft.scaleOptions = {
            ...draft.scaleOptions,
            leastValueText: value,
          };
        })
      );
    },
    [updateSelectedField, field]
  );

  const handleScaleTextMostChange = React.useCallback(
    (name: string, value: string) => {
      if (!field) return;

      updateSelectedField(
        produce(field, draft => {
          draft.scaleOptions = {
            ...draft.scaleOptions,
            mostValueText: value,
          };
        })
      );
    },
    [updateSelectedField, field]
  );

  if (!field || field.type !== 'scale') return null;

  return (
    <>
      <ContentTitle text="Scale Options" />
      <FormField
        field={leastValueField}
        value={field.scaleOptions?.leastValueText || ''}
        onChange={handleScaleTextLeastChange}
      />
      <FormField
        field={mostValueField}
        value={field.scaleOptions?.mostValueText || ''}
        onChange={handleScaleTextMostChange}
      />
    </>
  );
});
